module.exports = __webpack_public_path__ + "img/img2.81e77900.svg";